import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import { html } from 'lit';

export function buttonsTemplate(this: TefComs4csMicroFrontend) {
  return html`<div class="section section-buttons">
        <button
          class="button button-default"
          .disabled=${!this.store.hasModifiedConsents}
          @click=${async () => { await this.store.save(); }}>
          Speichern
        </button>
      </div>`;
}
